// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { ErrorAlert, IDVerificationPopUp, PageLoadingSpinner } from 'ui_kit_qmd'
import moment from 'moment'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import { getTabId, getTimeZones, parseTimeZone } from '../../utils/common'
import errorIcon from '../../images/common/error-icon.svg'
import IDVerificationPopUpListener from '../../store/id-verification-pop-up/IDVerificationPopUpListener'

const IDVerificationPopUpContainer = () => {
  const patientId = useRef('')
  const tabId = getTabId()
  const timezones = getTimeZones(allTimezones)

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)

  const [showPopUp, setShowPopUp] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [verification, setVerification] = useState({})
  const [userTimeZone, setUserTimeZone] = useState(parseTimeZone(profile?.TimeZone))
  const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })
  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  const [timeZoneAbbr, setTimeZoneAbbr] = useState(parseTimezone(parseTimeZone(profile?.TimeZone)).label)

  useEffect(() => {
    if (profile.TimeZone) {
      setUserTimeZone(parseTimeZone(profile.TimeZone))
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setTimeZoneAbbr(parseTimezone(parseTimeZone(profile?.TimeZone)).label)
    } else {
      setUserTimeZone(moment.tz.guess())
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setTimeZoneAbbr(parseTimezone(moment.tz.guess()).label)
    }
  }, [profile])

  const openFileVerification = useCallback(
    ({
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      PatientId,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      Url,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      Status,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      CompletedDateTime,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      VerificationId,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      PatientPhotoUrl,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      IdentityPhotoUrl,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      Overrides,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      ExpireDate,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      RequestDateTime,
    }) => {
      patientId.current = PatientId
      setVerification({
        Url,
        DateTime: CompletedDateTime,
        VerificationId,
        PatientPhotoUrl,
        IdentityPhotoUrl,
        Status,
        Overrides,
        ExpireDate,
        RequestDateTime,
      })
      setShowPopUp(true)
    },
    [setShowPopUp],
  )
  const closePopUp = useCallback(() => {
    patientId.current = ''
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setError('')
    setShowPopUp(false)
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const setToastMessage = useCallback((value) => {
    setError(value)
    setTimeout(() => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setError('')
    }, 3500)
  }, [])

  return (
    <>
      {loading ?
        <PageLoadingSpinner />
      : null}
      <IDVerificationPopUpListener
        onSetLoading={setLoading}
        setToastMessage={setToastMessage}
        tabId={tabId}
        onOpenFileVerification={openFileVerification}
        patientId={patientId.current}
      />
      {showPopUp ?
        <IDVerificationPopUp
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          status={verification.Status}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          url={verification.Url}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          dateTime={verification.DateTime}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          id={verification.VerificationId}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          selfie={verification.PatientPhotoUrl}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          idPhoto={verification.IdentityPhotoUrl}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          overrides={verification.Overrides}
          onClose={closePopUp}
          timeZoneAbbr={timeZoneAbbr}
          timeZone={userTimeZone}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          expireDate={verification.ExpireDate}
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          requestDateTime={verification.requestDateTime}
        />
      : null}
      {error ?
        <div className='file-pop-up-error-container'>
          <ErrorAlert errorText={error} errorImg={errorIcon} imgAlt='Error' />
        </div>
      : null}
    </>
  )
}

export default IDVerificationPopUpContainer
